
// import { Http, RequestOptions, RequestMethod, Headers } from "@angular/http";
import { OnDestroy } from "@angular/core";
import { IQuerySnapshot, IDocumentSnapshot, FieldPath, WhereFilterOp, OrderByDirection } from '../IDatabase';
import * as signalR from '@microsoft/signalr';
// import { number } from '@amcharts/amcharts4/core';
//import { UserService } from 'src/app/auth/core/_services';
import { of, Subject } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { HubConnection, HubConnectionState } from '@microsoft/signalr';

export const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
    })
};

export class MongoBody {
    path: string;
    data: any;
    queryOperations: QueryOperation[]
}

export class QueryOperation {
    key: string;
    fieldPath: string | FieldPath;
    fieldValues: any[];
    opStr: WhereFilterOp;
    value: any;
    directionStr?: OrderByDirection;
    limit: number;
}

export interface IChangeSnapshot {
    fullDocument: any;
    operationType: any;
    updateDescription: any;
    collectionNamespace: any
    documentKey: any;
    messageId: number;
}


export class ChangeListener {
    _fullPath: string;



    private static counter: number = 0;
    private _controlId: number;

    StopAsync(connection: signalR.HubConnection) {
        if (!connection) return;

        if (connection.state === signalR.HubConnectionState.Connected) {
            connection.send("StopListener", this._controlId.toString())
                .then()
                .catch(err => console.warn("⚠️ Erro ao enviar StopListener:", err));
        } else {
            console.warn(`⚠️ Não foi possível enviar StopListener, estado atual: ${connection.state}`);
        }
    }

    Listen(connection: signalR.HubConnection) {

        if (connection == null) return;

        if (connection.state != HubConnectionState.Connected) return;

        connection.send("Listen", this._controlId.toString(), this._fullPath, this.queryOperations);


    }
    Fire(value: IChangeSnapshot) {

        // console.log("Fire(value: IChangeSnapshot)");
        // console.log(value);

        this.callback(value);
    }
    Mach(value: IChangeSnapshot, fullPath: string, controlId: string): boolean {

        if (this._controlId.toString() == controlId && this._fullPath == fullPath) {

            return true;
        }
        return false;
    }

    constructor(private path: string, private id: string,
        private queryOperations: QueryOperation[],

        private callback: (change: IChangeSnapshot) => void) {


        this._controlId = ChangeListener.counter++;

        if (this.id != null) {
            this._fullPath = `${this.path}/${this.id}`;
        } else {
            this._fullPath = this.path;
        }
    }

    public controlId(): number {
        return this._controlId;
    }
}

export class ProgressListener {

    private _key: number;


    Fire(value: number) {

        this.callback(value);
    }
    Mach(key: string): boolean {

        if (this._key.toString() == key) {

            return true;
        }
        return false;
    }

    constructor(private key: string,
        private callback: (progress: number) => void) {

    }

}


